import {
	deleteGuestCreditCard,
	DeleteGuestCreditCardParams,
} from "@/api/credit-cards/credit-cards";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

export default function useDeleteCreditCard(
	options?: MutationOptionsWithoutFn<unknown, DeleteGuestCreditCardParams>,
) {
	return useMutation({
		mutationFn: deleteGuestCreditCard,
		...options,
	});
}
